/**
 * Saving a code block as a Markdown file. The owner, 2026-10-21 14:05: "should also have a downlaod button to down a copy
 * of the code as .txt too", then 17:26: "for the code download can we get it in markdown intead of txt". The save is the
 * one GeneratedFiles uses for a generated file: an object URL on a download anchor, the blob with an inert MIME, the URL
 * revoked after a minute. It works wherever GeneratedFiles downloads already land: the browser, the Office pane and the
 * desktop overlay's WebView2 (SpotlightOverlay does not cancel DownloadStarting).
 */
export const DOWNLOAD_URL_LIFETIME_MS = 60_000;
/** Saves `text` as a file named `fileName` through the browser's download path. */
export function saveTextAsFile(text, fileName) {
    const url = URL.createObjectURL(new Blob([text], { type: 'application/octet-stream' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.append(link);
    link.click();
    link.remove();
    const timer = setTimeout(() => URL.revokeObjectURL(url), DOWNLOAD_URL_LIFETIME_MS);
    // Under Node (tests) the pending revoke must not hold the process open; browsers return a number and ignore this.
    timer.unref?.();
}
/** A language label the fence carries as its tag: the chat's own rule for a code block's label (ChatMarkdown's CodeBlock). */
const FENCE_LANGUAGE = /^[\w+.#-]{1,60}$/;
/**
 * The Markdown document a code block downloads as: the block's exact code in one fenced code block carrying its language
 * tag (a plain fence when it has none), ending with a newline. The fence is three backticks, or one longer than the
 * longest run of three or more backticks inside the code, so nothing in the code can close it early.
 */
export function codeMarkdownDocument(code, language) {
    let longest = 0;
    for (const run of code.matchAll(/`+/g))
        longest = Math.max(longest, run[0].length);
    const fence = '`'.repeat(longest >= 3 ? longest + 1 : 3);
    const tag = FENCE_LANGUAGE.test(language) ? language : '';
    return fence + tag + '\n' + code + (code === '' || code.endsWith('\n') ? '' : '\n') + fence + '\n';
}
/**
 * The .md name a code block downloads under: gyro-<language>-<n>.md when the block's language label is a plain word
 * (letters and digits only, so `typescript` or `python`, never `c#` or `c++`), else gyro-code-<n>.md; `n` is the block's
 * position among the message's code blocks, counted from 1. Always the .md extension.
 */
export function codeDownloadName(language, ordinal) {
    const word = /^[a-z0-9]{1,30}$/i.test(language) ? language.toLowerCase() : 'code';
    const n = Number.isInteger(ordinal) && ordinal >= 1 ? ordinal : 1;
    // Joined, never a template literal with gyro- right before a hole: scripts/webStylesheet.mjs reads such a word as a
    // class prefix, and that one prefix would keep every gyro.css rule in the web stylesheet.
    return ['gyro', word, String(n)].join('-') + '.md';
}
//# sourceMappingURL=saveTextFile.js.map